import React, { useContext, useEffect } from 'react';
import Ok from '../../Dialog/Ok';
import { store } from './reducer';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import Filters from './Filters';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from './List';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    '& .results': {
      gridColumn: 'span 3',
      height: 200,
      overflowY: 'auto',
    },
  },
  chips: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexFlow: 'row wrap',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(0.5),
    },
  },
}));

const SearchDialog = ({ placeholder = 'انتخاب کاربر:', ...rest }) => {
  const classes = useStyles();
  const { state, dispatch } = useContext(store);
  const { dialog, progress, users, single } = state;
  const handleClose = () => {
    dispatch({ type: 'CLOSE_DIALOG' });
  };
  const handleDelete = (userId) => {
    dispatch({ type: 'REMOVE_USER', payload: userId });
  };

  useEffect(() => {
    if (single && users?.length > 0) {
      handleClose();
    }
  }, [users, single]);

  const SelectedUsers = ({ placeholder }) => {
    return (
      <div className={classes.chips}>
        <span style={{ marginLeft: 10 }}>{placeholder}</span>
        {users?.map((user) => (
          <Chip
            key={user._id}
            variant="outlined"
            color="primary"
            size="small"
            onDelete={() => handleDelete(user._id)}
            label={`${user?.firstName ? user.firstName + ' ' : ''}${
              user?.lastName ? user.lastName : ''
            }${user?.company ? `(${user.company})` : ''}`}
          />
        ))}
      </div>
    );
  };

  return (
    <Ok
      title={<SelectedUsers placeholder={placeholder} />}
      open={dialog}
      ok="بستن"
      onClose={handleClose}
      {...rest}
    >
      <div className={classes.root}>
        <Filters />
        <div className="results">
          {progress ? <LinearProgress /> : <List />}
        </div>
      </div>
    </Ok>
  );
};

export default SearchDialog;
